export const storyIdsFromDescription = (description: string): string[] => {
  if (description.length === 0 || !description.includes('#')) {
    return []
  }

  return description
    .split('#')
    .map((part) => part.replace(/[^0-9]+$/, '')) // Remove non-numeric characters at the end
    .map((part) => part.replace(/^0+/, '')) // Remove leading zeros
    .filter((part) => /^\d{9,}$/.test(part))
}
